module.exports = __webpack_public_path__ + "static/media/arpoison.509b6447.png";